import { Radio, RadioGroup } from '@headlessui/react'
import { StarIcon as StarOutlineIcon } from '@heroicons/react/24/outline'
import { StarIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import PropTypes from 'prop-types'

const StarRating = ({
  value = null,
  onChange,
  starSize = 'size-10',
  className = ''
}) => {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      className={clsx('flex space-x-1', className)}
    >
      {[1, 2, 3, 4, 5].map((rating, index) => {
        const filled = rating <= value

        return (
          <Radio
            key={index}
            value={rating}
            className={clsx(
              'cursor-pointer transition duration-200 hover:text-yellow-400',
              filled ? 'text-yellow-400' : 'text-gray-300'
            )}
          >
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: 'spring', stiffness: 300, damping: 32 }}
            >
              {filled ? (
                <StarIcon className={starSize} />
              ) : (
                <StarOutlineIcon className={starSize} />
              )}
            </motion.div>
          </Radio>
        )
      })}
    </RadioGroup>
  )
}

StarRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  starSize: PropTypes.string,
  className: PropTypes.string
}

export default StarRating
